import Store from 'lightningjs-redux';

import { getDeepLink } from '../../logic/routing/routing.selectors';

const mapControllers = instance => [
  {
    selector: getDeepLink,
    callback: value => {
      instance.deeplink = value;
    },
    shouldBeInvokedOnConnect: true,
  },
];

export default Store.control(mapControllers);
